import { toEmbedUrl, isDirectVideo } from "@/lib/video";

const VideoPlayer = ({ url }: { url: string }) => {
  const embed = toEmbedUrl(url);
  if (embed) {
    return (
      <div className="aspect-video rounded-2xl overflow-hidden bg-black">
        <iframe
          src={embed}
          title="Video"
          className="w-full h-full"
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
    );
  }
  if (isDirectVideo(url)) {
    return (
      <video controls className="w-full aspect-video rounded-2xl bg-black">
        <source src={url} />
      </video>
    );
  }
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className="text-primary underline text-sm">
      Watch video ↗
    </a>
  );
};

export default VideoPlayer;
